import { render, staticRenderFns } from "./flugverfuegbarkeiten-widget.vue?vue&type=template&id=799f0be9&scoped=true"
import script from "./flugverfuegbarkeiten-widget.vue?vue&type=script&lang=js"
export * from "./flugverfuegbarkeiten-widget.vue?vue&type=script&lang=js"
import style0 from "./flugverfuegbarkeiten-widget.vue?vue&type=style&index=0&id=799f0be9&prod&lang=scss&scoped=true"
import style1 from "./flugverfuegbarkeiten-widget.vue?vue&type=style&index=1&id=799f0be9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f0be9",
  null
  
)

export default component.exports